import NotArchivedPapers from "./NotArchivedPapers";

export default NotArchivedPapers;
